const SearchIcon = (props) => {
  return (
    <svg
      viewBox="0 0 23 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M22 22L17.0976 17.0976M19.7805 10.3902C19.7805 11.6234 19.5376 12.8445 19.0657 13.9837C18.5938 15.123 17.9021 16.1582 17.0301 17.0301C16.1582 17.9021 15.123 18.5938 13.9837 19.0657C12.8445 19.5376 11.6234 19.7805 10.3902 19.7805C9.1571 19.7805 7.93603 19.5376 6.79675 19.0657C5.65748 18.5938 4.6223 17.9021 3.75034 17.0301C2.87837 16.1582 2.18669 15.123 1.71479 13.9837C1.24289 12.8445 1 11.6234 1 10.3902C1 7.8998 1.98933 5.51135 3.75034 3.75034C5.51135 1.98933 7.8998 1 10.3902 1C12.8807 1 15.2691 1.98933 17.0301 3.75034C18.7912 5.51135 19.7805 7.8998 19.7805 10.3902Z"
        stroke={props.stroke ? props.stroke : '#262626'}
        strokeWidth={props.strokeWidth ? props.strokeWidth : '1.3'}
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

export default SearchIcon;
